import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";

export default function GlobalCtaButtons() {
	return (
		<div className="ctaemailbtn">
			<Link
				to="mailto:suzy@thebroadcaststore.co"
				className="bannerCtaButton">
				<MdEmail size={30} />
			</Link>
			<Link
				to="tel:747-609-5599"
				className="bannerEmailButton">
				<FaPhoneAlt size={30} />
			</Link>
		</div>
	);
}
